import { Button } from 'blaze-ui/Button'
import { Stars } from 'blaze-ui/icons'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'

import {
  CloudinaryEffectItem,
  CloudinaryEffectMenu,
} from 'common/Prose/nodeViews/Image/components/FormatBar/CloudinaryEffectMenu/CloudinaryEffectMenu'

interface Props {
  attrs: ImageNodeAttrs
  onFilter: () => void
}

export const EffectsMenu = ({ attrs, onFilter }: Props) => (
  <MenuTrigger>
    <Button frontIcon={Stars} variant="tertiary" rounded size="xs" aria-label="Effects">
      Effects
    </Button>
    <CloudinaryEffectMenu aria-label="Effects" attrs={attrs} onEffect={onFilter}>
      <CloudinaryEffectItem key="artisticFilter:al_dente">Apply artistic filter</CloudinaryEffectItem>
      <CloudinaryEffectItem key="sepia">Sepia</CloudinaryEffectItem>
      <CloudinaryEffectItem key="cartoonify">Cartoonify</CloudinaryEffectItem>
      <CloudinaryEffectItem key="pixelate:20">Pixelate</CloudinaryEffectItem>
      <CloudinaryEffectItem key="blur:400">Blur</CloudinaryEffectItem>
      <CloudinaryEffectItem key="oil_paint">Oil Paint</CloudinaryEffectItem>
      <CloudinaryEffectItem key="sharpen:400">Sharpen</CloudinaryEffectItem>
      <CloudinaryEffectItem key="vignette">Vignette</CloudinaryEffectItem>
    </CloudinaryEffectMenu>
  </MenuTrigger>
)
